import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

// GenerateItemMedicaoColumns 

type Props = {
  onActionEditar: (Id: number | null, openState: boolean, openAnalise: boolean) => void,
  onActionDeletar: (Id: number | null, openState: boolean) => void,
  validButton: boolean,
};

export const GenerateItemMedicaoColumns = ({
  onActionEditar,
  onActionDeletar,
  validButton
}: Props): GridColDef[] => {


  return [
    {
      field: "NomeProdutoServico",
      filterable: false,
      headerName: "Serviço",
      minWidth: 150,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "Unidade",
      filterable: false,
      headerName: "Unidade",
      flex: 1,
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => {
        return (<div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NomeSubConta",
      filterable: false,
      headerName: "Subconta",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      headerName: "Qtde",
      flex: 1,
      maxWidth: 100,
      sortable: false,
      renderCell: (params) => {
        return (<div className="w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "ValorUnitario",
      filterable: false,
      headerName: "Valor Unitário (R$)",
      flex: 1,
      maxWidth: 120,
      sortable: false,
      valueFormatter: (value: number | null | undefined) => {
          if (value == null) return ""; 
          return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(value);
        },
    },
    { 
      field: "ValorTotal",
      filterable: false,
      headerName: "Valor Total (R$)",
      flex: 1,
      maxWidth: 120,
      sortable: false,
      valueFormatter: (value: number | null | undefined) => {
          if (value == null) return ""; 
          return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(value);
        },
    },
    { 
      field: "Detalhamento",
      filterable: false,
      headerName: "Detalhamento",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: 'IdItemMedicaoTerceirizacao',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        if(validButton === false){
          return (
            <div className="flex items-center justify-center w-full h-full gap-2">
              <IconButton onClick={() => onActionEditar(params.value, true, false)}>
                <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
              </IconButton>
  
              <IconButton onClick={() => onActionDeletar(params.value, true)}>
                <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
              </IconButton>
            </div>
          );
        }
      }
    },
  ];
}